import Page from './Page';
import Component from 'vue-class-component';
import HeaderComponent from './Header.vue';
import template from './BillingBreakdown.vue.html';

type Breakdown = {
    item_name: string;
    amount: number;
};

@Component({ template, components: { HeaderComponent } })
export default class BillingBreakdown extends Page {
    breakdown: Breakdown[] = [];
    async created() {
        try {
            const response = await this.app.post('stripe-info');
            if (!response.succeed) throw new Error(response.error);
            this.breakdown = response.breakdown;
        } catch (error: any) {
            alert(error.message || 'Error');
        }
    }

    total() {
        if (!this.breakdown) return 0;
        return this.breakdown.reduce((sum, bill) => (sum += bill.amount), 0);
    }
}
